import React from "react";
import map from "lodash.map";
import isEmpty from "lodash.isempty";

import { Attachment } from "../../Attachment";

function renderAttachmentsIcon(type) {
  switch (type) {
    case "application/pdf": {
      return (
        <i className="fas fa-file-pdf attachments-list__icon attachments-list__icon--primary-dark" />
      );
    }
    default: {
      return (
        <i className="fas fa-file attachments-list__icon attachments-list__icon--primary-dark" />
      );
    }
  }
}
export const TermsOfUseCard = ({ ...props }) => {
  return (
    <div className="container">
      <h2 className="page__title">{props.title}</h2>
      <div
        className="page__content"
        dangerouslySetInnerHTML={{ __html: props.text }}
      />
      {!isEmpty(props.agreementHistoryFiles) && (
        <div className="page__attachments">
          <div className="attachments-list">
            {map(props.agreementHistoryFiles, (file) => (
              <Attachment
                key={file.id}
                {...{
                  attachment: file,
                  url: `/api/app/terms-of-use/${props.id}/file/${file.id}`,
                }}
              >
                {renderAttachmentsIcon(file.contentType)}
              </Attachment>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
